import React from 'react'
import m1 from "assets/images/users/1.jpg";
import m2 from "assets/images/users/2.jpg";
import m4 from "assets/images/users/4.jpg";
import m6 from "assets/images/users/6.jpg";
import m7 from "assets/images/users/7.jpg";
import m9 from "assets/images/users/9.jpg";
import fm1 from "assets/images/users/01.jpg";
import fm3 from "assets/images/users/03.jpg";
import fm8 from "assets/images/users/08.jpg";
export default function RealTimeCollaborator({ endCollaborationHandler }: any) {
  const collaborators = [
    {
      name: "Lana Steiner",
      image: fm1,
    },
    {
      name: "Charlie Roman",
      image: m1,
    },
    {
      name: "Orlando Diggs",
      image: fm3,
    },
    {
      name: "Kate Morrison",
      image: fm8,
    },
    {
      name: "Demi Wikinson",
      image: m7,
    },
    {
      name: "Candice Wu",
      image: m2,
    },
    {
      name: "Alex Craig",
      image: m6,
    },
    {
      name: "Drew Cano",
      image: m4,
    },
    {
      name: "Andi Lee",
      image: m9,
    },
  ];

  const userNameLable = {
    zIndex: 10,
    background: "rgba(26, 26, 36, 0.8)",
    bottom: "10px",
    left: "20px",
    whiteSpace: "nowrap",
    fontSize: "18px",
    padding: "4px 8px",
  } as React.CSSProperties;

  return (
    <div className="ph-3 ">
      <header className="d-flex justify-content-between mb-5">
        <div className="fw-300">
          <h3>Real Time Collaborator</h3>
          <span className="text-gray-500">Descritpion</span>
        </div>

        <button
          onClick={() => endCollaborationHandler()}
          className="btn bg-error-600 text-white ph-4 btn-danger"
        >
          <i className="mr-3 icon-phone-off"></i>
          End Call
        </button>
      </header>

      <div className="row g-3">
        {collaborators.map((collaborator, i) => (
          <div key={i} className="col-4 position-relative">
            <img
              src={collaborator.image}
              alt={collaborator.name}
              className="fw"
            />
            <span style={userNameLable} className="position-absolute">
              {collaborator.name}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
